// Routes owned by the Oncall module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const oncallPaths = {
    // Oncall Management
    oncall: '/oncall',
    oncallSchedules: '/oncall/schedules',
    oncallScheduleCreate: '/oncall/schedules/new',
    oncallScheduleDetail: '/oncall/schedules/:id',
    oncallScheduleEdit: '/oncall/schedules/:id/edit',
    oncallAssignments: '/oncall/assignments',
    oncallAssignmentDetail: '/oncall/assignments/:id',
    oncallSwaps: '/oncall/swaps',
    oncallSwapCreate: '/oncall/swaps/new',
    oncallSwapDetail: '/oncall/swaps/:id',
    oncallCompensations: '/oncall/compensations',
    oncallCompensationReport: '/oncall/compensations/report',
    oncallCompensationDetail: '/oncall/compensations/:id',
    oncallLogs: '/oncall/logs',
} as const
